import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RadioComponent } from '@ui/radio/radio.component';

@NgModule({
    declarations: [RadioComponent],
    imports: [CommonModule],
    exports: [RadioComponent],
})
export class RadioModule {}
